export enum ServicesProject {
  GARANZIA_VIAGGI = 'GARANZIA_VIAGGI'
}
